import { useState } from "react";
import useApplicationContext from "./apollo/applicationContext/useApplicationContext";

export default function usePendo() {
  const { user, site, settings, role, pendoEnabled, company } = useApplicationContext();
  const [initialized, setInitialized] = useState(false);

  if (pendoEnabled && !initialized) {
    pendo.initialize({
      account: {
        companyName: company?.name,
        id: site?.id,
        productLedGrowthCustomer: Boolean(settings?.productLedGrowthCustomer),
        siteCreatedAt: site?.createdAt,
        siteId: site?.id,
        siteName: site?.name,
      },
      visitor: {
        id: user?.id,
        role,
        screenAvailableHeight: window.screen.availHeight,
        screenAvailableWidth: window.screen.availWidth,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
      },
    });

    setInitialized(true);
  }
}
